import { apiCall } from "./AxiosService";
import { API_URL } from "./APIRoute";

const BASE = API_URL.BASEURL;

export const EKSNodeGroupService = {
    getList: async () => {
        try {
            const response = await apiCall({
                method: "POST",
                url: `${BASE}${API_URL.EKS_NODE_GROUP.GET_LIST}`,
                body: {},
            }, true);
            return response;
        } catch (error) {
            throw error;
        }
    },

    save: async (data) => {
        try {
            const response = await apiCall({
                method: "POST",
                url: `${BASE}${API_URL.EKS_NODE_GROUP.SAVE}`,
                body: data,
            }, true);
            return response;
        } catch (error) {
            throw error;
        }
    },

    delete: async (data) => {
        try {
            const response = await apiCall({
                method: "POST",
                url: `${BASE}${API_URL.EKS_NODE_GROUP.DELETE}`,
                body: data,
            }, true);
            return response;
        } catch (error) {
            throw error;
        }
    },

    updateMinSize: async (data) => {
        try {
            const response = await apiCall({
                method: "POST",
                url: `${BASE}${API_URL.EKS_NODE_GROUP.UPDATE_MIN_SIZE}`,
                body: data,
            }, true);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getSubnet: async () => {
        try {
            const response = await apiCall({
                method: "GET",
                url: `${BASE}${API_URL.EKS_NODE_GROUP.GET_SUBNET}`,
                body: {},
            }, false);
            return response;
        } catch (error) {
            throw error;
        }
    },

    getAwsInstances: async () => {
        try {
            const response = await apiCall({
                method: "GET",
                url: `${BASE}${API_URL.EKS_NODE_GROUP.GET_AWS_INSTANCES}`,
                body: {},
            }, false);
            return response;
        } catch (error) {
            throw error;
        }
    },

    checkStatusByInstanceName: async (instanceName) => {
        try {
            const response = await apiCall({
                method: "GET",
                url: `${BASE}${API_URL.EKS_NODE_GROUP.CHECK_STATUS}?instanceName=${encodeURIComponent(instanceName)}`,
                body: {},
            }, false);
            return response;
        } catch (error) {
            throw error;
        }
    },
};